RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Collection = Backbone.Collection.extend({
        url: '/api/configurations/reports',
        model: Marionette.Dashboard.models.Configuration
    });

    const ReportConfigurations = RivalIQ.data.CacheLayer.extend({
        name: 'Report Configurations',
        cacheKeys: [],

        loadData: function () {
            const collection = new Collection();

            return collection.fetch().then(function () {
                return collection;
            });
        },

        fetch: function () {
            const me = this;
            return me.getOrLoad();
        }
    });

    data.reportConfigurations = new ReportConfigurations();
});
